var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loading-dots', _vm.loadingDotsClasses]},_vm._l((3),function(dot){return _c('div',{key:dot,class:['loading-dot', ("dot-" + dot)]})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }